import { Colors, Services } from '@sigma-frontend-libs/commons'

import { sizes } from '@/utils'

import squircle from '@/components/icon/squircle'

function renderIcon(h, { tooltip, icon }) {
  return h(
    squircle,
    {
      props: {
        tooltip,
        icon,
        color: Colors.grey,
        size: sizes.medium
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services['url-shortener']}-expire`
    },
    this.items.map(item => {
      return renderIcon(h, item)
    })
  )
}
